export const EMOJIS = ["👍", "❤️", "😂", "🔥", "😮", "😢", "🎉", "👏", "💪", "🙏", "🖕", "💩"];

// Curated public GIF library (Giphy). Broken URLs are auto-hidden by the onError handler.
export const GIF_LIBRARY = [
  { label: "Thumbs up", url: "https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif" },
  { label: "Fire", url: "https://media.giphy.com/media/l0MYryZTmQgvHI5TG/giphy.gif" },
  { label: "Heart", url: "https://media.giphy.com/media/3o6nUS81rEwOTb9DK0/giphy.gif" },
  { label: "LOL", url: "https://media.giphy.com/media/l0MYzTPCyPz9OhK9y/giphy.gif" },
  { label: "Middle finger", url: "https://media.giphy.com/media/xT8qBff86Y3Q6cegha/giphy.gif" },
  { label: "Party", url: "https://media.giphy.com/media/26FPqAHtgCBzKG9GM/giphy.gif" },
  { label: "Flex", url: "https://media.giphy.com/media/3o6ZsWZM8mfvLU3tCU/giphy.gif" },
  { label: "Clap", url: "https://media.giphy.com/media/4xpB3eE00FfBm/giphy.gif" },
  { label: "Cry", url: "https://media.giphy.com/media/l2Sq3aTIgcNo6DXHW/giphy.gif" },
  { label: "Mind blown", url: "https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif" },
  { label: "Facepalm", url: "https://media.giphy.com/media/xUOxeSXV0mPZQfvxAQ/giphy.gif" },
  { label: "Nope", url: "https://media.giphy.com/media/l4KhQo2MESJkc6QbS/giphy.gif" },
  { label: "Ok", url: "https://media.giphy.com/media/xT0xezQGU5xCDJuCPe/giphy.gif" },
  { label: "Bart", url: "https://media.giphy.com/media/8CTgAxVUgYE0M/giphy.gif" },
  { label: "Cool", url: "https://media.giphy.com/media/xT39D80cWCJUUcCFOw/giphy.gif" },
  { label: "Yes", url: "https://media.giphy.com/media/xTiTnEbU5LRhaxIWJi/giphy.gif" },
  { label: "Applause", url: "https://media.giphy.com/media/3o7abKhOpu0NwenH3O/giphy.gif" },
  { label: "Confused", url: "https://media.giphy.com/media/3og0IPxMM0erATueVW/giphy.gif" },
  { label: "Rocket", url: "https://media.giphy.com/media/3ohhwoWZTiuGeyaKcU/giphy.gif" },
  { label: "Kiss", url: "https://media.giphy.com/media/l0Iy3jSCcqzhs7cJ2/giphy.gif" },
];

export function fmt(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const same = d.toDateString() === now.toDateString();
  return same
    ? d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function initials(name) {
  return (name || "?").split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();
}

export { API } from "@/lib/api";
